module.exports = __webpack_public_path__ + "static/AlexFitch_Resume-61eafbb3976c89ec089162159483dcd4.pdf";